'use client';

import { goServiceMainWithoutAuth } from '@/utils/functions';
import type { Route } from 'next';
import type { Session } from 'next-auth';
import Link from 'next/link';
import styles from './CommonFooter.module.scss';

type MenuListItem = { href?: string; to?: Route; onClick?: () => void; text: string };

function CommonFooter({
  siteName,
  sessionData,
}: {
  siteName: string;
  sessionData?: Session | null;
}) {
  // toはサイト内リンク、hrefは外部リンク
  const menuListLeft: MenuListItem[] = sessionData?.user
    ? [
        { to: '/auth/signin', text: 'ログイン・新規会員登録' },
        { to: '/lotteries?tab=is_session', text: '開催中のくじ一覧' },
        {
          onClick: () => {
            goServiceMainWithoutAuth({ path: '/faq' });
          },
          text: 'よくある質問',
        },
        {
          onClick: () => {
            goServiceMainWithoutAuth({ path: '/contact' });
          },
          text: 'お問い合わせ',
        },
        { to: '/informations', text: 'お知らせ' },
      ]
    : [
        { to: '/auth/signin', text: 'ログイン・新規会員登録' },
        { to: '/lotteries?tab=is_session', text: '開催中のくじ一覧' },
        {
          onClick: () => {
            goServiceMainWithoutAuth({ path: '/faq' });
          },
          text: 'よくある質問',
        },
        { to: '/informations', text: 'お知らせ' },
      ];

  const menuListRight: MenuListItem[] = [
    { to: '/terms', text: '利用規約' },
    {
      href: 'https://fogg.jp/privacy',
      text: '個人情報保護方針',
    },
    {
      to: '/policy',
      text: '個人情報の取扱いについて',
    },
    { to: '/tokusho', text: '特定商取引法に基づく表記' },
    { to: '/shikin', text: '資金決済法に基づく表記' },
    { to: '/keihin', text: '景品のお取り扱いについての注意事項' },
  ];

  return (
    <footer className={styles.componentStyle}>
      <div className={styles.container}>
        <div className={styles.footerTitle}>
          <img src='/logo-white.png' alt={siteName} />
        </div>
        <div className={styles.menuListWrapper}>
          <ul className={styles.menuList}>{menuList(menuListLeft)}</ul>
          <ul className={styles.menuList}>{menuList(menuListRight)}</ul>
        </div>
        <p className={styles.copyright}>Copyrights 2022 JUNON TV. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

function listInnerJsx(item: MenuListItem) {
  if (item.onClick)
    return (
      // biome-ignore lint/a11y/useValidAnchor: <explanation>
      <a
        href='#'
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          if (!item.onClick) return;
          item.onClick();
        }}
      >
        {item.text}
      </a>
    );

  if (item.href) return <a href={item.href}>{item.text}</a>;

  return (
    <Link href={item.to as Route} prefetch={false}>
      {item.text}
    </Link>
  );
}

function menuList(list: MenuListItem[]) {
  const result: Array<React.ReactNode> = [];
  list.forEach((item, index) => {
    result.push(
      <li
        key={`menu_${
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          index
        }`}
      >
        {listInnerJsx(item)}
      </li>,
    );
  });

  return result;
}

export default CommonFooter;
